import {
  DASHBOARD_LOADING_CHART,
  DASHBOARD_SELECT_SCHOOL,
  DASHBOARD_WIDGET_MODE,
  GET_DASHBOARD_STATS_START,
  GET_DASHBOARD_STATS_SUCCESS,
  GET_DASHBOARD_STATS_FAIL,
} from "./actions";

const schoolSwitcherDefault = {
  isLoading: false,
  selected: null,
  mode: "all",
};
const initState = {
  enrolledStudentsSchool: schoolSwitcherDefault,
  averageGradesSchool: schoolSwitcherDefault,
  monthlyAbsencesSchool: schoolSwitcherDefault,
  stats: { admissions: 0, enrollment: 0, revenue: 0, applications: 0 },
  recentApplications: [],
  newEnrollees: [],
  enrollmentByGrade: null,
  isLoading: false,
};

const dashboardReducer = (state = initState, action) => {
  switch (action.type) {
    case DASHBOARD_LOADING_CHART:
      return {
        ...state,
        [action.chart]: {
          ...state[action.chart],
          isLoading: action.isLoading,
        },
      };
    case DASHBOARD_SELECT_SCHOOL:
      return {
        ...state,
        [action.chart]: {
          ...state[action.chart],
          selected: action.selected,
        },
      };
    case DASHBOARD_WIDGET_MODE:
      return {
        ...state,
        [action.chart]: {
          ...state[action.chart],
          mode: action.mode,
        },
      };
    case GET_DASHBOARD_STATS_START:
      return { ...state, isLoading: true };
    case GET_DASHBOARD_STATS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        stats: action.payload.stats,
        recentApplications: action.payload.recentApplications,
        newEnrollees: action.payload.newEnrollees,
        enrollmentByGrade: action.payload.enrollmentByGrade,
        enrollmentGenderSplit: action.payload.enrollmentGenderSplit,
      };
    case GET_DASHBOARD_STATS_FAIL:
      return { ...state, isLoading: false, error: action.error };
    default:
      return state;
  }
};

export default dashboardReducer;
